import moment from 'moment-timezone'

import { availableRollingPeriodEnd } from 'services/calendar_service'

export const getDefaultDays = (rules) => {
  const dayKeys = ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday']

  return dayKeys.reduce((defaultDays, dayKey) => {
    const day = rules.find((r) => r.wday === dayKey)

    return {
      ...defaultDays,
      [dayKey]: day ? day.intervals : []
    }
  }, {})
}

export const getEventTypePeriodStart = (periodType, startDate, timezone) => {
  if (periodType === 'fixed') {
    return startDate && moment.tz(startDate, timezone)
  }

  return null
}

export const getEventTypePeriodEnd = (periodType, movingType, maxBookingTime, endDate, timezone) => {
  const today = moment.tz(timezone).startOf('day')
  const rollingPeriod = Math.round(maxBookingTime)

  if (periodType === 'rollingDays') {
    if (movingType === 'business') {
      return availableRollingPeriodEnd(today, rollingPeriod)
    }
    return today.clone().add({ days: rollingPeriod })
  }

  if (periodType === 'fixed') {
    return moment.tz(endDate, timezone)
  }

  return null
}
